import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { requestPasswordReset } from '@/api/auth';
import { AUTH_RATE_LIMIT_PATHS, applyAuthRateLimitFromError, formatAuthRateLimitMessage, getAuthCooldownRemaining, } from '@/api/authRateLimit';
import { parseApiErrorMessage } from '@/api/errors';
import { useAuthCooldown } from '@/hooks/useAuthCooldown';
import { isValidEmail } from '@/utils/email';
import './Auth.css';
export function ForgotPasswordPage() {
    const navigate = useNavigate();
    const cooldown = useAuthCooldown(AUTH_RATE_LIMIT_PATHS.passwordResetRequest);
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const displayError = cooldown > 0 ? formatAuthRateLimitMessage(cooldown) : error;
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (getAuthCooldownRemaining(AUTH_RATE_LIMIT_PATHS.passwordResetRequest) > 0)
            return;
        setError('');
        const emailTrim = email.trim();
        if (!isValidEmail(emailTrim)) {
            setError('Укажите корректный email');
            return;
        }
        setLoading(true);
        try {
            await requestPasswordReset(emailTrim);
            navigate('/reset-password', { state: { email: emailTrim } });
        }
        catch (err) {
            if (applyAuthRateLimitFromError(err, AUTH_RATE_LIMIT_PATHS.passwordResetRequest)) {
                setError('');
                return;
            }
            setError(parseApiErrorMessage(err, 'Не удалось отправить код'));
        }
        finally {
            setLoading(false);
        }
    };
    return (_jsx("div", { className: "auth-page", children: _jsxs("div", { className: "auth-card", children: [_jsx("h1", { className: "auth-title", children: "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0430\u0440\u043E\u043B\u044F" }), _jsx("p", { className: "auth-subtitle", children: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 email - \u043F\u0440\u0438\u0448\u043B\u0451\u043C \u043A\u043E\u0434 \u0434\u043B\u044F \u0441\u043C\u0435\u043D\u044B \u043F\u0430\u0440\u043E\u043B\u044F" }), displayError && _jsx("div", { className: "auth-error", children: displayError }), _jsxs("form", { onSubmit: handleSubmit, className: "auth-form", children: [_jsxs("div", { className: "auth-field", children: [_jsx("label", { htmlFor: "forgot-email", children: "Email" }), _jsx("input", { id: "forgot-email", type: "email", value: email, onChange: (e) => setEmail(e.target.value), placeholder: "user@example.com", autoComplete: "username", required: true }), _jsx("span", { className: "auth-hint", children: "\u0415\u0441\u043B\u0438 \u0442\u0430\u043A\u043E\u0439 email \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D, \u043C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043C \u043D\u0430 \u043D\u0435\u0433\u043E \u043A\u043E\u0434" })] }), _jsx("button", { type: "submit", className: "auth-submit", disabled: loading || cooldown > 0, children: cooldown > 0
                                ? formatAuthRateLimitMessage(cooldown)
                                : loading
                                    ? 'Отправка…'
                                    : 'Отправить код' })] }), _jsx("p", { className: "auth-footer", children: _jsx(Link, { to: "/login", children: "\u041D\u0430\u0437\u0430\u0434 \u043A\u043E \u0432\u0445\u043E\u0434\u0443" }) })] }) }));
}
